module.exports = __webpack_public_path__ + "static/media/sack.2c45934f.svg";